export default "__VITE_ASSET__s1NC614c__"